const ROOT = 'POSITION_AVAILABILITY_';

const actions = {
  FETCH_OPTIONS_REQUEST: `${ROOT}FETCH_OPTIONS_REQUEST`,
  FETCH_OPTIONS_SUCCESS: `${ROOT}FETCH_OPTIONS_SUCCESS`,
  FETCH_OPTIONS_ERROR: `${ROOT}FETCH_OPTIONS_ERROR`,
  FETCH_OVERVIEW_REQUEST: `${ROOT}FETCH_OVERVIEW_REQUEST`,
  FETCH_OVERVIEW_SUCCESS: `${ROOT}FETCH_OVERVIEW_SUCCESS`,
  FETCH_OVERVIEW_ERROR: `${ROOT}FETCH_OVERVIEW_ERROR`,
  FETCH_POSITION_REQUEST: `${ROOT}FETCH_POSITION_REQUEST`,
  FETCH_POSITION_SUCCESS: `${ROOT}FETCH_POSITION_SUCCESS`,
  FETCH_POSITION_ERROR: `${ROOT}FETCH_POSITION_ERROR`,
  FETCH_PAIR_REQUEST: `${ROOT}FETCH_PAIR_REQUEST`,
  FETCH_PAIR_SUCCESS: `${ROOT}FETCH_PAIR_SUCCESS`,
  FETCH_PAIR_ERROR: `${ROOT}FETCH_PAIR_ERROR`,
  CLEAR_STORE: `${ROOT}CLEAR_STORE`,
} as const;

export default actions;
